import { useIsAdmin } from '@/modules/auth/hooks';
import { MenuDesktop } from '@/modules/layout';
import { UserGuideSecretsView } from '@/modules/user-guide/components';

import { SidebarContent } from '../SidebarContent';
import { desktopAlignOffset } from '../SidebarMobile';
import { UserMenu } from '../UserMenu';

export const SidebarDesktop = () => {
    const isAdmin = useIsAdmin();

    return (
        <MenuDesktop>
            {isAdmin ? (
                <UserGuideSecretsView
                    placement='rightTop'
                    align={{
                        offset: desktopAlignOffset,
                    }}
                >
                    <UserMenu />
                </UserGuideSecretsView>
            ) : (
                <UserMenu />
            )}
            <SidebarContent />
        </MenuDesktop>
    );
};
